import type { WeddingEvent, UserPreferences } from './types';
import { formatTime } from './utils';

export interface NotificationPayload {
  id: string;        // `${eventId}:${leadMinutes}` for dedup
  fireAt: number;    // ms timestamp
  title: string;
  body: string;
}

export function calculateNotifications(
  events: WeddingEvent[],
  prefs: UserPreferences
): NotificationPayload[] {
  const now = Date.now();
  const results: NotificationPayload[] = [];

  for (const event of events) {
    if (!event.notify) continue;
    const categoryMatch =
      prefs.categoryFilter.includes('all') || prefs.categoryFilter.includes(event.category);
    if (!categoryMatch) continue;

    for (const leadMinutes of prefs.notifyLeadTimes) {
      const fireAt = new Date(event.startTime).getTime() - leadMinutes * 60_000;
      if (fireAt <= now) continue;

      const title =
        leadMinutes === 0 ? `NOW: ${event.name}` : `${leadMinutes} min — ${event.name}`;
      const body = [formatTime(event.startTime), event.location].filter(Boolean).join(' · ');

      results.push({ id: `${event.id}:${leadMinutes}`, fireAt, title, body });
    }
  }
  return results;
}

export async function requestPermission(): Promise<NotificationPermission> {
  if (!('Notification' in window)) return 'denied';
  return await Notification.requestPermission();
}

export function scheduleAll(notifications: NotificationPayload[]): void {
  if (!('serviceWorker' in navigator)) return;
  navigator.serviceWorker.ready.then((reg) => {
    reg.active?.postMessage({ type: 'schedule', notifications });
  });
}

export function cancelAll(): void {
  if (!('serviceWorker' in navigator)) return;
  navigator.serviceWorker.ready.then((reg) => {
    reg.active?.postMessage({ type: 'cancel' });
  });
}
